import React from 'react';
export function HeroSection() {
  return <section className="relative pb-16 overflow-hidden bg-light-pink" data-id="element-72">
      {/* Scrolling Marquee */}
      <div className="bg-pink-400 text-white py-2 overflow-hidden whitespace-nowrap relative z-20" data-id="element-73">
        <div className="inline-block animate-marquee font-bold tracking-wider text-sm" data-id="element-74">
          <span className="mx-4" data-id="element-75">LIMITED TIME OFFER 50% OFF</span>
          <span className="mx-4" data-id="element-76">·</span>
          <span className="mx-4" data-id="element-77">WELCOME</span>
          <span className="mx-4" data-id="element-78">LIMITED TIME OFFER 50% OFF</span>
          <span className="mx-4" data-id="element-79">·</span>
          <span className="mx-4" data-id="element-80">WELCOME</span>
          <span className="mx-4" data-id="element-81">LIMITED TIME OFFER 50% OFF</span>
          <span className="mx-4" data-id="element-82">·</span>
          <span className="mx-4" data-id="element-83">WELCOME</span>
          <span className="mx-4" data-id="element-84">LIMITED TIME OFFER 50% OFF</span>
          <span className="mx-4" data-id="element-85">·</span>
          <span className="mx-4" data-id="element-86">WELCOME</span>
        </div>
      </div>

      {/* Decorative Confetti/Stars */}
      <div className="absolute inset-0 pointer-events-none z-0" data-id="element-87">
        <div className="absolute top-20 left-10 text-white text-4xl opacity-50 animate-pulse" data-id="element-88">
          ✨
        </div>
        <div className="absolute top-40 right-20 text-white text-5xl opacity-50 animate-pulse delay-75" data-id="element-89">
          ✨
        </div>
        <div className="absolute top-80 left-1/4 text-white text-3xl opacity-50 animate-pulse delay-150" data-id="element-90">
          ✨
        </div>
        <div className="absolute top-60 right-1/4 text-white text-4xl opacity-50 animate-pulse delay-300" data-id="element-91">
          ✨
        </div>

        {/* White confetti rectangles */}
        <div className="absolute top-32 left-32 w-4 h-8 bg-white opacity-40 rotate-45 rounded-sm" data-id="element-92"></div>
        <div className="absolute top-24 right-40 w-3 h-6 bg-white opacity-40 -rotate-12 rounded-sm" data-id="element-93"></div>
        <div className="absolute top-72 left-1/3 w-5 h-10 bg-white opacity-40 rotate-12 rounded-sm" data-id="element-94"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10 text-center mt-12 px-4" data-id="element-95">
        {/* Balloon Arch */}
        <div className="relative h-48 md:h-64 max-w-3xl mx-auto mb-8 flex justify-center items-center" data-id="element-96">
          <div className="absolute w-24 h-24 md:w-32 md:h-32 bg-pink-200 rounded-full opacity-80 -left-4 md:left-0 top-20 animate-float" style={{
          animationDelay: '0s'
        }} data-id="element-97"></div>
          <div className="absolute w-28 h-28 md:w-40 md:h-40 bg-pink-400 rounded-full opacity-90 left-10 md:left-20 top-10 animate-float" style={{
          animationDelay: '0.2s'
        }} data-id="element-98"></div>
          <div className="absolute w-20 h-20 md:w-28 md:h-28 bg-pink-300 rounded-full opacity-90 left-24 md:left-40 top-24 animate-float" style={{
          animationDelay: '0.4s'
        }} data-id="element-99"></div>
          <div className="absolute w-32 h-32 md:w-48 md:h-48 bg-pink-500 rounded-full opacity-90 left-1/4 md:left-1/3 top-0 animate-float" style={{
          animationDelay: '0.6s'
        }} data-id="element-100"></div>
          <div className="absolute w-24 h-24 md:w-32 md:h-32 bg-orange-300 rounded-full opacity-90 left-1/2 -translate-x-1/2 top-12 animate-float" style={{
          animationDelay: '0.8s'
        }} data-id="element-101"></div>
          <div className="absolute w-32 h-32 md:w-44 md:h-44 bg-orange-400 rounded-full opacity-90 right-1/4 md:right-1/3 top-4 animate-float" style={{
          animationDelay: '1s'
        }} data-id="element-102"></div>
          <div className="absolute w-20 h-20 md:w-28 md:h-28 bg-orange-200 rounded-full opacity-90 right-24 md:right-40 top-20 animate-float" style={{
          animationDelay: '1.2s'
        }} data-id="element-103"></div>
          <div className="absolute w-28 h-28 md:w-40 md:h-40 bg-teal-400 rounded-full opacity-90 right-10 md:right-20 top-12 animate-float" style={{
          animationDelay: '1.4s'
        }} data-id="element-104"></div>
          <div className="absolute w-24 h-24 md:w-36 md:h-36 bg-teal-200 rounded-full opacity-80 -right-4 md:right-0 top-24 animate-float" style={{
          animationDelay: '1.6s'
        }} data-id="element-105"></div>
        </div>

        {/* Typography */}
        <div className="bg-white/90 backdrop-blur-sm rounded-[3rem] p-8 md:p-12 shadow-xl border-4 border-white mb-12 relative z-20" data-id="element-106">
          <h2 className="text-pink-400 text-xl md:text-2xl font-bold tracking-[0.3em] uppercase mb-2 font-nunito" data-id="element-107">
            CREATE THE
          </h2>

          <h1 className="text-6xl md:text-8xl lg:text-9xl font-extrabold mb-4 leading-none drop-shadow-sm font-baloo" data-id="element-108">
            <span className="text-pink-400" data-id="element-109">B</span>
            <span className="text-orange-400" data-id="element-110">e</span>
            <span className="text-pink-500" data-id="element-111">s</span>
            <span className="text-teal-400" data-id="element-112">t</span>
            <span data-id="element-113"> </span>
            <span className="text-teal-300" data-id="element-114">p</span>
            <span className="text-pink-400" data-id="element-115">a</span>
            <span className="text-orange-400" data-id="element-116">r</span>
            <span className="text-pink-500" data-id="element-117">t</span>
            <span className="text-teal-400" data-id="element-118">y</span>
          </h1>

          <h3 className="text-4xl md:text-5xl lg:text-6xl text-teal-500 italic font-baloo mb-8" data-id="element-119">
            for your kids!
          </h3>

          <p className="text-lg md:text-xl text-gray-700 font-semibold mb-8 max-w-2xl mx-auto" data-id="element-120">
            The kit with{' '}
            <span className="text-magenta font-bold text-2xl" data-id="element-121">
              +10,000 customizable templates
            </span>
            , ready to download, print, and set up from home — even if you have
            no experience or want to start your first creative stationery
            business.
          </p>

          {/* Themed party collage */}
          <div className="w-full max-w-2xl mx-auto mb-10 grid grid-cols-2 gap-3 md:gap-4" data-id="element-122">
            <img src="https://cdn.magicpatterns.com/uploads/co2pLTjTDDq2gZL41fMZHP/Decoracao_Para_Festa_Infantil_em_Osasco,_Sp.jpg" alt="Peppa Pig kids party decoration" className="col-span-1 w-full h-48 md:h-64 object-cover rounded-2xl shadow-xl border-4 border-white transform -rotate-2 hover:rotate-0 hover:scale-105 transition-all duration-300" data-id="element-123" />
            <img src="https://cdn.magicpatterns.com/uploads/uTAbWGogdRezMVyijMmKjt/Paw_Patrol_Birthday_Party_Ideas___Photo_4_of_15.jpg" alt="Paw Patrol kids party decoration" className="col-span-1 w-full h-48 md:h-64 object-cover rounded-2xl shadow-xl border-4 border-white transform rotate-2 hover:rotate-0 hover:scale-105 transition-all duration-300" data-id="element-124" />
            <img src="https://cdn.magicpatterns.com/uploads/m6tbarF6Ayh84z6Yj1NSEA/Portada_Deco_bo.jpg" alt="Bluey kids party decoration" className="col-span-2 w-full h-56 md:h-72 object-cover rounded-2xl shadow-xl border-4 border-white transform hover:scale-[1.02] transition-all duration-300" data-id="element-125" />
          </div>

          <a href="#pricing" className="inline-block bg-pink-500 text-white font-baloo font-bold text-2xl md:text-3xl py-4 px-8 md:px-12 rounded-full shadow-[0_8px_0_#D81B60] hover:shadow-[0_4px_0_#D81B60] hover:translate-y-1 transition-all duration-200 animate-bounce" data-id="element-126">
            👇 YES, I WANT MY PARTY KIT 👇
          </a>
          <p className="mt-4 text-sm md:text-base font-semibold text-gray-500 uppercase tracking-wider" data-id="element-127">
            Instant access · One-time payment · No subscriptions
          </p>
        </div>
      </div>
    </section>;
}